import styled from 'styled-components';

export const StyledWrapper = styled.div`
  display: flex;
  flex-direction: row;
  border: 0.1rem solid ${({ theme }) => theme.colors.black};
  gap: 1.6rem;
  padding: 1rem;
  background-color: ${({ theme }) => theme.colors.white};
`;

export const StyledActivity = styled.div`
  display: flex;
  border: 0.1rem solid ${({ theme }) => theme.colors.black};
  padding: 1rem;
  background-color: ${({ theme }) => theme.colors.info.light};
`;

export const StyledCategory = styled.div`
  display: flex;
  border: 0.1rem solid ${({ theme }) => theme.colors.black};
  padding: 1rem;
  color: ${({ theme }) => theme.colors.info.main};
  font-weight: ${({ theme }) => theme.fonts.weight.bold};
`;
